import { useEffect, useRef, useState, type ReactElement } from 'react';

import { getStratoLogger } from '../../../core/sdk/sdk-logger.js';

export const useResolveAsyncComponent = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  asyncComponentCallback: (() => Promise<ReactElement<any>>) | undefined,
  shouldRun: boolean,
  deps: unknown[] = [],
) => {
  const logger = getStratoLogger('useResolveAsyncComponent');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [syncComponent, setSyncComponent] = useState<ReactElement<any> | null>(
    null,
  );
  const errorCount = useRef(0);

  useEffect(() => {
    if (!shouldRun) {
      setSyncComponent(null);
    }
  }, [shouldRun]);

  useEffect(() => {
    if (!asyncComponentCallback || !shouldRun || syncComponent) {
      return;
    }

    asyncComponentCallback()
      .then((template) => template && setSyncComponent(template))
      .catch((error) => {
        logger.error('Failed to load async component ', error);
        errorCount.current += 1;
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logger, asyncComponentCallback, errorCount.current, shouldRun, ...deps]);

  return syncComponent;
};
